import ClubPermissionIntraKey from '../dto/ClubPermissionIntraKey';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubPermissionIntraKeyRepository {

    static find(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/physical-access/permissions/intra-key`)
                .then(response => resolve(response.data.data.map(data => ClubPermissionIntraKey.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

}
